module.exports = __webpack_public_path__ + "img/8AE19500-D395-40D3-9268-B59DE5D22188.f7aa4ecc.jpg";